import React from 'react';
import '../styles/privacy.css'; // Create a privacy.css for styling

function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p>Your privacy is important to us. It is Ronni Ceramics' policy to respect your privacy regarding any information we may collect from you across our website.</p>

      <h2>1. Information We Collect</h2>
      <p>We may collect personal information such as your name, email address, phone number, and postal address when you register on our website, place an order, subscribe to our newsletter, or fill out a form.</p>

      <h2>2. How We Use Your Information</h2>
      <p>We use your information to:</p>
      <ul>
        <li>Process orders and provide customer support</li>
        <li>Send you newsletters and promotional materials</li>
        <li>Improve our website and services</li>
        <li>Respond to your inquiries and requests</li>
      </ul>

      <h2>3. Data Security</h2>
      <p>We implement a variety of security measures to maintain the safety of your personal information when you place an order or enter, submit, or access your personal information.</p>

      <h2>4. Sharing Your Information</h2>
      <p>We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information. This does not include trusted third parties who assist us in operating our website, conducting our business, or serving you, so long as those parties agree to keep this information confidential.</p>

      <h2>5. Cookies</h2>
      <p>We use cookies to enhance your experience on our website. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information.</p>

      <h2>6. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access the personal information we hold about you</li>
        <li>Correct any inaccuracies in your personal information</li>
        <li>Request that we delete your personal information</li>
      </ul>

      <h2>7. Changes to Our Privacy Policy</h2>
      <p>If we decide to change our privacy policy, we will post those changes on this page.</p>

      <h2>8. Contact Information</h2>
      <p>If you have any questions about this privacy policy, please contact us at ronniceramics@gmail.com.</p>
    </div>
  );
}

export default PrivacyPolicy;